import { createRouter, createWebHashHistory } from "vue-router";
import { authenticated, canAccess, firstAllowedPage } from "@/stores/admin.js";
const sources = import.meta.glob("./views/*.vue");
export const pageFiles = {
  overview: "OverviewPage",
  members: "MembersPage",
  merchants: "MerchantsPage",
  articles: "ArticlesPage",
  orders: "OrdersPage",
  funds: "FundsPage",
  withdrawals: "WithdrawalsPage",
  applications: "ApplicationsPage",
  notice: "NoticePage",
  pages: "AgreementPage",
  admins: "AdminsPage",
  settings: "SettingsPage",
  security: "SecurityPage",
};
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: () =>
        authenticated.value ? "/" + firstAllowedPage() : "/login",
    },
    { path: "/login", component: () => import("./views/LoginPage.vue") },
    {
      path: "/no-access",
      component: () => import("./views/NoAccessPage.vue"),
      meta: { title: "无可用权限" },
    },
    ...Object.entries(pageFiles).map(([key, file]) => ({
      path: "/" + key,
      component: sources[`./views/${file}.vue`],
      meta: { permission: key },
    })),
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
  scrollBehavior: () => ({ top: 0 }),
});
router.beforeEach((to) => {
  if (to.path === "/login") return true;
  if (!authenticated.value)
    return { path: "/login", query: { redirect: to.fullPath } };
  if (to.path === "/no-access") return true;
  if (!canAccess(to.meta.permission)) return "/" + firstAllowedPage();
});
window.addEventListener("admin-session-expired", () =>
  router.replace("/login"),
);
export default router;
